import { createFileRoute } from '@tanstack/react-router'
import { ServerCogIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/processes')({
  staticData: {
    title: 'Processes',
    crumb: 'Processes',
    icon: ServerCogIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
